/**
 * MOVO has three separate apps in one web client. Which one you get is decided by the
 * role on your account, never by a switcher in the UI.
 */
export type Audience = 'owner' | 'tenant' | 'internal';

export const AUDIENCES: readonly Audience[] = ['owner', 'tenant', 'internal'];

export const AUDIENCE_HOME: Record<Audience, string> = {
  owner: '/app',
  tenant: '/tenant',
  internal: '/internal',
};

export const AUDIENCE_LOGIN: Record<Audience, string> = {
  owner: '/login/owner',
  tenant: '/login/tenant',
  internal: '/login/team',
};

export const AUDIENCE_LABEL: Record<Audience, string> = {
  owner: 'Property owner',
  tenant: 'Resident',
  internal: 'MOVO team',
};

const ROLE_AUDIENCE: Record<string, Audience> = {
  OWNER: 'owner',
  MANAGER: 'owner',
  STAFF: 'owner',
  TENANT: 'tenant',
  SUPER_ADMIN: 'internal',
  PLATFORM_ADMIN: 'internal',
  PLATFORM_SUPPORT: 'internal',
};

export function audienceForRole(role: string | null | undefined): Audience | null {
  return (role && ROLE_AUDIENCE[role]) || null;
}

const ROLE_LABEL: Record<string, string> = {
  OWNER: 'Owner',
  MANAGER: 'Manager',
  STAFF: 'Staff',
  TENANT: 'Resident',
  SUPER_ADMIN: 'Platform admin',
  PLATFORM_ADMIN: 'Platform admin',
  PLATFORM_SUPPORT: 'Support',
};

export function roleLabel(role: string | null | undefined): string {
  return (role && ROLE_LABEL[role]) || 'User';
}
